(function () {
    'use strict';

    angular.module("imApp").factory("productCategorysService", ['$ihttp', function ($ihttp) {
        let service = {
            listProductCategories: function (parms) {
                return $ihttp.post({
                    method: 2711,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
